const ProfileRoutine = {
  State_0: "ProfileRoutine.State_0",
  State_1: "ProfileRoutine.State_1",
  State_2: "ProfileRoutine.State_2",
  Frequency_1: "ProfileRoutine.Frequency_1",
  Frequency_2: "ProfileRoutine.Frequency_2",
  Frequency_3: "ProfileRoutine.Frequency_3",
  Frequency_4: "ProfileRoutine.Frequency_4",
  Frequency_5: "ProfileRoutine.Frequency_5",
  RoutineMarkedAsDone: "ProfileRoutine.RoutineMarkedAsDone",
  }
export default ProfileRoutine;